var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "c-section",
    {
      ref: "section",
      staticClass: "cog-rating-scale",
      class: {
        "cog-table-bands": !_vm.chameleon,
        ["cog-field--" + _vm.fieldIndex]: _vm.fieldIndex
      },
      attrs: {
        cols: _vm.cols,
        source: _vm.$source,
        "hide-label": _vm.hideLabel
      }
    },
    [
      _vm.$source.readonly
        ? _c("table", [
            _c(
              "tbody",
              [
                _vm._l(_vm.questions, function(question) {
                  return [
                    _c("vm-source", {
                      key: question,
                      attrs: { source: question },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ $source: field }) {
                              return [
                                _c("tr", [
                                  _c(
                                    "th",
                                    {
                                      staticClass: "cog-rating-scale__question"
                                    },
                                    [
                                      _c(
                                        "label",
                                        [
                                          _vm._t(
                                            "readonly-question-label",
                                            function() {
                                              return [
                                                _vm._v(_vm._s(field.label))
                                              ]
                                            },
                                            { item: field }
                                          ),
                                          _vm._v(" "),
                                          _vm.showAsterisk(field)
                                            ? _c(
                                                "span",
                                                { staticClass: "cog-asterisk" },
                                                [_vm._v("*")]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.isDirty &&
                                          _vm.lostFocus &&
                                          field.firstError
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "cog-error-message cog-error-message--inline"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$resource(
                                                        "required-asterisk"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    [
                                      _vm._t(
                                        "readonly-question-value",
                                        function() {
                                          return [
                                            _vm._v(_vm._s(field.displayValue))
                                          ]
                                        },
                                        { item: field }
                                      )
                                    ],
                                    2
                                  )
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ]
                })
              ],
              2
            )
          ])
        : !_vm.condensed
        ? _c(
            "table",
            [
              _c("vm-source", {
                attrs: { source: _vm.questions[0] },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ $source }) {
                      return [
                        _c(
                          "thead",
                          [
                            _c("th"),
                            _vm._v(" "),
                            _vm._l(_vm.ratings, function(rating, i) {
                              return _c(
                                "th",
                                {
                                  key: rating.value,
                                  attrs: { id: `cog-${$source.parent.id}-${i}` }
                                },
                                [_c("span", [_vm._v(_vm._s(rating.value))])]
                              )
                            })
                          ],
                          2
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.questions, function(question) {
                    return [
                      _c("vm-source", {
                        key: question,
                        attrs: { source: question },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ $source: field }) {
                                return [
                                  _c(
                                    "el-radio-group",
                                    {
                                      tag: "tr",
                                      class: { "is-required": field.required },
                                      attrs: { chameleon: _vm.chameleon },
                                      model: {
                                        value: field.value,
                                        callback: function($$v) {
                                          _vm.$set(field, "value", $$v)
                                        },
                                        expression: "field.value"
                                      }
                                    },
                                    [
                                      _c(
                                        "th",
                                        {
                                          staticClass:
                                            "cog-rating-scale__question"
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              attrs: { id: "cog-" + field.id }
                                            },
                                            [
                                              _vm._v(_vm._s(field.label)),
                                              _vm.showAsterisk(field)
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "cog-asterisk",
                                                      attrs: {
                                                        "aria-hidden": "true"
                                                      }
                                                    },
                                                    [_vm._v("*")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              field.required &&
                                              !(
                                                _vm.isDirty &&
                                                _vm.lostFocus &&
                                                field.firstError
                                              )
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "cog-offscreen"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "(" +
                                                          _vm._s(
                                                            _vm.$resource(
                                                              "required-asterisk"
                                                            )
                                                          ) +
                                                          ")"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.isDirty &&
                                              _vm.lostFocus &&
                                              field.firstError
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "cog-offscreen"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "(" +
                                                          _vm._s(
                                                            field.firstError
                                                          ) +
                                                          ")"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.isDirty &&
                                          _vm.lostFocus &&
                                          field.firstError
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "cog-error-message cog-error-message--inline"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$resource(
                                                        "required-asterisk"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.ratings, function(rating, i) {
                                        return _c(
                                          "td",
                                          {
                                            key: rating.value,
                                            staticClass:
                                              "cog-rating-scale__option",
                                            attrs: { "aria-hidden": "true" }
                                          },
                                          [
                                            _c("el-radio", {
                                              attrs: {
                                                chameleon: _vm.chameleon,
                                                label: rating.value,
                                                "aria-labelledby": `cog-${field.id} cog-${field.parent.id}-${i}`
                                              },
                                              model: {
                                                value: field.value,
                                                callback: function($$v) {
                                                  _vm.$set(field, "value", $$v)
                                                },
                                                expression: "field.value"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ]
                  })
                ],
                2
              )
            ],
            1
          )
        : _vm._l(_vm.questions, function(question, i) {
            return [
              _c(
                "c-row",
                { key: question },
                [
                  _c("c-field", {
                    attrs: { "field-index": i, source: question },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ field }) {
                            return [
                              _c("c-select", {
                                attrs: {
                                  id: field.id,
                                  scope: _vm.scope,
                                  options: _vm.ratings,
                                  chameleon: _vm.chameleon,
                                  mobile: _vm.mobile
                                },
                                model: {
                                  value: field.displayValue,
                                  callback: function($$v) {
                                    _vm.$set(field, "displayValue", $$v)
                                  },
                                  expression: "field.displayValue"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                ],
                1
              )
            ]
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }